var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-card");
/**
 * This is the root card component that should be used along side all the other
 * card parts. It adds some general styles and elevation to help show
 * prominence.
 */
export var Card = forwardRef(function Card(_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.raiseable, raiseable = _b === void 0 ? false : _b, _c = _a.raisable, raisable = _c === void 0 ? raiseable : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, _e = _a.bordered, bordered = _e === void 0 ? false : _e, props = __rest(_a, ["className", "children", "raiseable", "raisable", "fullWidth", "bordered"]);
    return (_jsx("div", __assign({}, props, { ref: ref, className: cn(block({
            bordered: bordered,
            shadowed: !bordered,
            raisable: !bordered && raisable,
            "full-width": fullWidth,
        }), className) }, { children: children })));
});
//# sourceMappingURL=Card.js.map